import {BestattungsArt} from './enums';
import {Termin} from './termin';

/**
 * Bestattungsdaten.
 *
 * @author Andreas Wenger <andi@xenoage.com>
 */
export class Bestattung {

  //Bestattungs-Art und -Ort
  art: BestattungsArt;
	ort: string;
  friedhof: string;
  grablage: string;
  bestattung: Termin = new Termin();

  //Trauerfeier
  trauerfeier: Termin = new Termin();
  trauerfeierOrt: string;

  //Weitere Anmerkungen
  bemerkung: string;
  pfarrei: string;
  musik: string;

}



// WEBPACK FOOTER //
// ./src/model/bestattung.ts